<div class="app-info-container" [ngClass]="{ 'full-screen-app-info-container': isFullScreen }">
  <div class="image" [ngClass]="{ 'full-screen-image': isFullScreen }">
    <img
      *ngIf="isFullScreen"
      src="assets/images/homescreen-with-card.png"
      alt="Purposeful on mobile device with an open card" />
    <img *ngIf="!isFullScreen" src="assets/images/homescreen.png" alt="Purposeful on mobile device" />
  </div>
  <div class="app-info">
    <h3 class="app-info-topic" [ngClass]="{ 'full-screen-app-info-topic': isFullScreen }">
      Download the Purposeful app!
    </h3>
    <p class="app-info-content" [ngClass]="{ 'full-screen-app-info-content': isFullScreen }">
      Get support for living purposefully and being your best self with the Purposeful app, available for your
      smartphone or tablet.
    </p>
    <div class="app-locations">
      <a class="app-store" href="https://apps.apple.com/us/app/purposeful-by-kumanu/id1457841328" target="_blank">
        <img src="assets/icons/app-store.png" alt="Apple Badge with Download on the App Store text" />
      </a>
      <a
        class="google-play"
        href="https://play.google.com/store/apps/details?id=com.kumanu.purposeful&hl=en_US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
        target="_blank">
        <img src="assets/icons/google-play-badge.png" alt="Google Badge with Get it on Google Play text" />
      </a>
    </div>
  </div>
</div>
